<div class="portfolio page-layout" *transloco="let t">
  <p *ngIf="portfolioActivityStats$ | async as portfolioActivityStats" class="head-text">
    <span class="portfolio-activity-stats fw-bold">
      {{ t('pap/portfolio/priceForPeriod') }} / {{ t('pap/portfolio/paidByKindergarten') }}:
      <span class="count ms-1">{{ portfolioActivityStats.totalPrice | number : '1.0-0' }}</span>
      <span class="count-text">{{ t('shared/czk') }}</span>
      <span class="mx-2">/</span>
      <span class="count">{{ computePaidByKindergarten(portfolioActivityStats) | number : '1.0-0' }}</span>
      <span class="count-text">{{ t('shared/czk') }}</span>
    </span>
  </p>
  <app-pap-portfolio-filter (filterUpdated)="setFilter($event)" (export)="exportPage($event)" (print)="printPage()">
  </app-pap-portfolio-filter>

  <ng-container *ngIf="portfolioActivityList$ | withLoader | async as portfolioActivityList">
    <div class="portfolio-activity-list page-layout-sub no-gutters">
      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ t('pap/portfolio/dateStart') }}</th>
              <th scope="col">{{ t('pap/portfolio/teacher') }}</th>
              <th scope="col">{{ t('pap/portfolio/activityTitle') }}</th>
              <th scope="col">{{ t('pap/portfolio/activityType') }}</th>
              <th scope="col" class="text-end">{{ t('pap/portfolio/price') }}</th>
              <th scope="col" class="text-end">{{ t('pap/portfolio/selfPayer') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="portfolioActivityList.results.length > 0; else noResults">
              <app-pap-portfolio-row
                *ngFor="let portfolioActivity of portfolioActivityList.results"
                [portfolioActivity]="portfolioActivity"
                (click)="openPortfolioActivity(portfolioActivity)"
              ></app-pap-portfolio-row>
            </ng-container>

            <ng-template #noResults>
              <tr class="no-results" height="76px">
                <td>
                  {{ t('pap/portfolio/noResults') }}
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>

    <app-pagination
      *ngIf="portfolioActivityList.results.length > 0"
      [(page)]="page"
      (pageChange)="onPageChange($event)"
      [collectionSize]="portfolioActivityList.count"
      [pageSize]="limit"
      [showLimitSelector]="true"
      (limitChange)="onLimitChange($event)"
    ></app-pagination>
  </ng-container>
</div>
